import { VueContextType } from "@iloq/shared-react/vueContext";
import { Fragment, ReactNode } from "react";
import { IntlProvider } from "react-intl";
import { PartnerOverlay } from "./partner-overlay";
import ReactAppContainer from "@iloq/shared-react/ReactAppContainer";
import { IPartnerInfo } from "@iloq/shared/IPartnerInfo";

export function PartnerOverlayProvider(
  props: VueContextType & { partnerInfo: IPartnerInfo },
): ReactNode {
  return (
    <ReactAppContainer vueProps={props}>
      <IntlProvider
        locale={props.locale}
        messages={props.messages[props.locale]}
        textComponent={Fragment}
      >
        <PartnerOverlay partnerInfo={props.partnerInfo} tier={props.partnerInfo.marketingTier!} />
      </IntlProvider>
    </ReactAppContainer>
  );
}
